module.exports = __webpack_public_path__ + "img/161.146a4593.jpg";